module.exports = __webpack_public_path__ + "static/img/li5_1.672902c5.png";